/**
 * Helper: เก็บข้อมูลเพิ่มจาก LIFF SDK ที่ไม่อยู่ใน profile/idToken
 *   - getLanguage() — th/en/ja
 *   - getOS()       — ios/android/web
 *   - getFriendship() — friend/not friend
 */
import { liff } from './liff';

export interface LiffExtraContext {
  language: string | null;
  os: string | null;
  friend_status: 'friend' | 'not_friend' | 'unknown';
  status_message: string | null;
  email: string | null;             // จาก id_token (LINE)
}

export async function getLiffExtraContext(): Promise<LiffExtraContext> {
  const ctx: LiffExtraContext = {
    language: null,
    os: null,
    friend_status: 'unknown',
    status_message: null,
    email: null,
  };

  try { ctx.language = liff.getLanguage(); } catch {/* */}
  try { ctx.os = liff.getOS() ?? null; } catch {/* */}

  try {
    const decoded = liff.getDecodedIDToken();
    if (decoded?.email) ctx.email = decoded.email;
  } catch {/* */}

  try {
    const profile = await liff.getProfile();
    if (profile?.statusMessage) ctx.status_message = profile.statusMessage;
  } catch {/* */}

  try {
    const f = await liff.getFriendship();
    ctx.friend_status = f.friendFlag ? 'friend' : 'not_friend';
  } catch {
    ctx.friend_status = 'unknown';
  }

  return ctx;
}
